// extracted by mini-css-extract-plugin
export default {"cardGallerySkeleton":"skeleton_cardGallerySkeleton__A-TYd","skeleton":"skeleton_skeleton__h0DrI"};